export default __webpack_public_path__ + "static/media/defaultImage2.aa634de5.jpg";